import {
  cartItemMatchesMutationTarget,
  type CartLineIdentity,
  type CartLineMutationTarget,
} from "./cartIdentity";

type EventProductUuidLike = {
  productUuid?: unknown;
};

type CartLineWithQuantity = CartLineIdentity & {
  quantity: number;
};

export function resolveEventProductUuid(
  entity: EventProductUuidLike
): string | undefined {
  if (typeof entity.productUuid !== "string") {
    return undefined;
  }
  const trimmed = entity.productUuid.trim();
  return trimmed || undefined;
}


export function eventCartMutationTarget({
  productUuid,
  eventRef,
}: {
  productUuid: string;
  eventRef?: string;
}): CartLineMutationTarget {
  return {
    productUuid,
    eventRef,
  };
}

export function getEventCartLineQuantity(
  cartItems: CartLineWithQuantity[],
  target: CartLineMutationTarget,
): number {
  const line = cartItems.find((item) =>
    cartItemMatchesMutationTarget(item, target)
  );
  return line?.quantity ?? 0;
}

export function getEventCartInputKey(
  productUuid: string,
  eventRef: string
): string {
  return `${productUuid}-${eventRef}`;
}
